var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScopesActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 14.25H15.75C14.9216 14.25 14.25 14.9216 14.25 15.75V21C14.25 21.8284 14.9216 22.5 15.75 22.5H21C21.8284 22.5 22.5 21.8284 22.5 21V15.75C22.5 14.9216 21.8284 14.25 21 14.25Z",
    stroke: "#CC0000",
    strokeWidth: 1.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.25 14.25H27C26.1716 14.25 25.5 14.9216 25.5 15.75V21C25.5 21.8284 26.1716 22.5 27 22.5H32.25C33.0784 22.5 33.75 21.8284 33.75 21V15.75C33.75 14.9216 33.0784 14.25 32.25 14.25Z",
    stroke: "#CC0000",
    strokeWidth: 1.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 25.5H15.75C14.9216 25.5 14.25 26.1716 14.25 27V32.25C14.25 33.0784 14.9216 33.75 15.75 33.75H21C21.8284 33.75 22.5 33.0784 22.5 32.25V27C22.5 26.1716 21.8284 25.5 21 25.5Z",
    stroke: "#CC0000",
    strokeWidth: 1.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.25 25.5H27C26.1716 25.5 25.5 26.1716 25.5 27V32.25C25.5 33.0784 26.1716 33.75 27 33.75H32.25C33.0784 33.75 33.75 33.0784 33.75 32.25V27C33.75 26.1716 33.0784 25.5 32.25 25.5Z",
    stroke: "#CC0000",
    strokeWidth: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScopesActive);
export default __webpack_public_path__ + "static/media/scopes-active.2412b9065bf09a38abda86f7212cdafa.svg";
export { ForwardRef as ReactComponent };